import React, { ReactNode, useEffect, useState } from "react";

interface Props {
  children: ReactNode;
  visible?: boolean;
  isSlide?: boolean;
  edge?: "center" | "bottom";
  close?: () => void;
  backdropRemove?: boolean;
}

export function AnimatedModal(props: Props) {
  const {
    children,
    visible,
    close,
    isSlide,
    edge = "center",
    backdropRemove = true,
  } = props;
  const [vision, setVision] = useState(false);

  useEffect(() => {
    if (visible) {
      setVision(true);
    } else {
      setVision(false);
      close && close();
    }
  }, [visible]);

  const handleClose = () => {
    if (backdropRemove) {
      setVision(false);
      close && close();
    }
  };

  let edgePosition = { justifyContent: "center", alignItems: "center" };
  switch (edge) {
    case "bottom":
      edgePosition = { justifyContent: "flex-end", alignItems: "center" };
      break;
    case "center":
    default:
      break;
  }
  if (vision) {
    return (
      <>
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            height: "100vh",
            display: "flex",
            backgroundColor: "rgba(0,0,0,0.4)",
            ...edgePosition,
          }}
          onClick={handleClose}
        ></div>
        <div
          style={{
            position: "sticky",
            bottom: 0,
            zIndex: 110,
          }}
        >
          <div
            style={{
              width: "100%",
              transform: visible ? "translateY(0)" : "translateY(100%)",
              transition: "transform 0.3s ease",
              backgroundColor: "white",
              overflow: "hidden",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {children}
          </div>
        </div>
      </>
    );
  }
  return <></>;
}
